import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import ApplicationDetailsReport from './ApplicationDetailsReport'
import ApplicationFileDeliveryList from './ApplicationFileDeliveryList'

const AdminReports = () => {
  const { path } = useRouteMatch()
  const [selectedSection, setSelectedSection] = useState('details')

  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="details">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              <Nav.Item className="custom-nav-item">
                <Nav.Link
                  onClick={() => {
                    setSelectedSection('details')
                  }}
                  eventKey="details"
                >
                  Application Details Report
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="custom-nav-item">
                <Nav.Link
                  onClick={() => {
                    setSelectedSection('payment')
                  }}
                  eventKey="delivery"
                >
                  Application File Delivery List
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'details' ? (
              <ApplicationDetailsReport />
            ) : (
              <ApplicationFileDeliveryList />
            )}
          </Row>
        </Tab.Container>
      </Route>
    </Switch>
  )
}

export default AdminReports
